const UNA = {
  rojo: '#9B1D20',
  rojoOscuro: '#7a1518',
  rojoClaro: '#f9eaea',
  gris: '#f5f5f5',
  texto: '#1a1a1a',
  textoSuave: '#666',
};

export default UNA;